import {Resources} from "../resources/Resources";
import {Network} from "./Network";

export class NetworkVendor {

    public static images: { lang: string, name: string }[] = [
        {name: "blog-r.webp", lang: "es"},
        {name: "blog-s.webp", lang: "es"},
        {name: "blog-t.webp", lang: "es"},
        {name: "blog-w.webp", lang: "es"},
        {name: "blog-c.webp", lang: "es"},
        {name: "blog-bb.mp4", lang: "es"},
        {name: "blog-bc.mp4", lang: "es"},
        {name: "blog-bd.mp4", lang: "es"},
        {name: "blog-be.mp4", lang: "es"},
        {name: "blog-bf.mp4", lang: "es"},
    ]

    public static website2Images: { name: string, langs?: string[] }[] = [
        {name: "home-overview.webp", langs: ["fr", "es", "it"]},
        {name: "home-ai.webp", langs: ["fr", "es", "it"]},
        {name: "home-article.webp", langs: ["fr", "es", "it"]},
        {name: "home-score.webp", langs: ["fr", "es", "it"]},
        {name: "blog-subject.webp", langs: ["fr", "es", "it"]},
        {name: "blog-calendar.webp", langs: ["fr", "es", "it"]},
        {name: "blog-article.webp", langs: ["fr", "es", "it"]},
        {name: "blog-data.webp", langs: ["fr", "es", "it"]},
        {name: "blog-style.webp", langs: ["fr", "es", "it"]},
        {name: "blog-chat.webp", langs: ["fr", "es", "it"]},
        {name: "blog-stats.webp", langs: ["fr", "es", "it"]},
        {name: "blog-cta.webp", langs: ["fr", "es", "it"]},
        {name: "opti-list.webp", langs: ["fr", "es", "it"]},
        {name: "opti-opti.webp", langs: ["fr", "es", "it"]},
        {name: "opti-work.webp", langs: ["fr", "es", "it"]},
        {name: "opti-alert.webp", langs: ["fr", "es", "it"]},
        {name: "opti-page-type.webp", langs: ["fr", "es", "it"]},
        {name: "opti-score.webp", langs: ["fr", "es", "it"]},
        {name: "opti-message.webp", langs: ["fr", "es", "it"]},
        {name: "opti-chat.webp", langs: ["fr", "es", "it"]},
        {name: "compet-overview.webp", langs: ["fr", "es", "it"]},
        {name: "compet-competitors.webp", langs: ["fr", "es", "it"]},
        {name: "compet-competitor.webp", langs: ["fr", "es", "it"]},
        {name: "compet-vs.webp", langs: ["fr", "es", "it"]},
        {name: "compet-keywords.webp", langs: ["fr", "es", "it"]},
        {name: "compet-pages.webp", langs: ["fr", "es", "it"]},
        {name: "compet-any.webp", langs: ["fr", "es", "it"]},
        {name: "compet-stats.webp", langs: ["fr", "es", "it"]},
        {name: "media-overview.webp", langs: ["fr", "es", "it"]},
        {name: "media-image.webp", langs: ["fr", "es", "it"]},
        {name: "media-add.webp", langs: ["fr", "es", "it"]},
        {name: "media-create.webp", langs: ["fr", "es", "it"]},
        {name: "media-chat.webp", langs: ["fr", "es", "it"]},
        {name: "media-import.webp", langs: ["fr", "es", "it"]},
        {name: "media-style.webp", langs: ["fr", "es", "it"]},
        {name: "backlink-authority.webp", langs: ["fr", "es", "it"]},
        {name: "backlink-campagins.webp", langs: ["fr", "es", "it"]},
        {name: "backlink-strategy.webp", langs: ["fr", "es", "it"]},
        {name: "backlink-buy.webp", langs: ["fr", "es", "it"]},
        {name: "backlink-data.webp", langs: ["fr", "es", "it"]},
        {name: "backlink-choice.webp", langs: ["fr", "es", "it"]},
        {name: "backlink-metrics.webp", langs: ["fr", "es", "it"]},
        {name: "backlink-track.webp", langs: ["fr", "es", "it"]},
        {name: "index-overview.webp", langs: ["fr", "es", "it"]},
        {name: "index-indexing.webp", langs: ["fr", "es", "it"]},
        {name: "index-autopilot.webp", langs: ["fr", "es", "it"]},
        {name: "index-discover.webp", langs: ["fr", "es", "it"]},
        {name: "index-status.webp", langs: ["fr", "es", "it"]},
        {name: "index-request.webp", langs: ["fr", "es", "it"]},
        {name: "index-history.webp", langs: ["fr", "es", "it"]},
        {name: "index-filters.webp", langs: ["fr", "es", "it"]},
        {name: "seo-home.webp", langs: ["fr", "es", "it"]},
        {name: "seo-pages.webp", langs: ["fr", "es", "it"]},
        {name: "seo-keywords.webp", langs: ["fr", "es", "it"]},
        {name: "ai-overview.webp", langs: ["fr", "es", "it"]},
        {name: "ai-prompts.webp", langs: ["fr", "es", "it"]},
        {name: "ai-sources.webp", langs: ["fr", "es", "it"]},
        {name: "keywords-home.webp", langs: ["fr", "es", "it"]},
        {name: "keywords-details.webp", langs: ["fr", "es", "it"]},
        {name: "keywords-opportunity.webp", langs: ["fr", "es", "it"]},
        {name: "cannib-home.webp", langs: ["fr", "es", "it"]},
        {name: "cannib-recommend.webp", langs: ["fr", "es", "it"]},
        {name: "tech-home.webp", langs: ["fr", "es", "it"]},
        {name: "tech-priority.webp", langs: ["fr", "es", "it"]},
        {name: "tech-fix.webp", langs: ["fr", "es", "it"]},
        {name: "agency-home.webp", langs: ["fr", "es", "it"]},
        {name: "agency-brand.webp", langs: ["fr", "es", "it"]},
        {name: "agency-websites.webp", langs: ["fr", "es", "it"]},
        {name: "agency-work.webp"},
        {name: "agency-reports.webp"},
        {name: "included-article-1.webp", langs: ["fr", "es", "it"]},
        {name: "included-article-2.webp", langs: ["fr", "es", "it"]},
        {name: "included-article-3.webp", langs: ["fr", "es", "it"]},
        {name: "included-article-4.webp", langs: ["fr", "es", "it"]},
        {name: "included-visual-1.webp", langs: ["fr", "es", "it"]},
        {name: "included-visual-2.webp", langs: ["fr", "es", "it"]},
        {name: "included-visual-3.webp", langs: ["fr", "es", "it"]},
        {name: "included-visual-4.webp", langs: ["fr", "es", "it"]},
        {name: "included-visual-5.webp", langs: ["fr", "es", "it"]},
        {name: "included-visual-6.webp", langs: ["fr", "es", "it"]},
        {name: "included-visual-7.webp", langs: ["fr", "es", "it"]},
        {name: "included-visual-8.webp", langs: ["fr", "es", "it"]},
        {name: "included-chat.webp", langs: ["fr", "es", "it"]},
        {name: "activateur-france-num.jpg"},
    ]

    public static website2(name: string): string {
        let image = this.website2Images.find(value => {
            return value.name == name;
        });

        if (image == undefined) {
            return this.image(name);
        }

        let lang = Resources.language;

        if (image.langs != undefined && image.langs.includes(lang)) {
            return `${Network.vendor}images/website2/${lang}/${name}`;
        } else {
            return `${Network.vendor}images/website2/${name}`;
        }
    }

    public static image(name: string): string {
        let lang = Resources.language;

        if (this.images.find(value => {
            return value.lang == lang && value.name == name;
        })) {
            return `${Network.vendor}images/${lang}/${name}`;
        } else {
            return `${Network.vendor}images/en/${name}`;
        }
    }

    public static illus(name: string) {
        return `${Network.vendor}images/${name}`;
    }

    public static customer(name: string) {
        return `${Network.vendor}images/customers/${name}`;
    }
}